import JsonView from 'react18-json-view'

export function JsonViewer({ src, theme }: { src: any; theme: string }) {
	const config = {
		src,
		name: false,
		collapsed: false,
		collapseStringsAfterLength: 30,
		shouldCollapse: (field: { name: string; src: any }) => {
			if (
				field.name &&
				typeof field.src === 'object' &&
				Object.keys(field.src).length > 5
			) {
				return true
			} else {
				return false
			}
		},
		enableClipboard: true,
		style: {
			fontSize: '0.83rem',
			lineHeight: '1.1rem',
		},
	}
	if (theme && theme === 'dark') {
		//@ts-ignore
		config.theme = 'twilight'
	}
	return <JsonView {...config} />
}
